export default __webpack_public_path__ + "static/media/wifi-off.0f5ba026.svg";